import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Banner = _resolveComponent("Banner")!
  const _component_KeyFeatures = _resolveComponent("KeyFeatures")!
  const _component_TailorYourDashboard = _resolveComponent("TailorYourDashboard")!
  const _component_Testimonials = _resolveComponent("Testimonials")!
  const _component_OurTeam = _resolveComponent("OurTeam")!
  const _component_FAQ = _resolveComponent("FAQ")!
  const _component_ContactUs = _resolveComponent("ContactUs")!
  const _component_CTA = _resolveComponent("CTA")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_CopyRight = _resolveComponent("CopyRight")!
  const _component_BackToUp = _resolveComponent("BackToUp")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar, { class: "bg-white" }),
    _createVNode(_component_Banner),
    _createVNode(_component_KeyFeatures),
    _createVNode(_component_TailorYourDashboard),
    _createVNode(_component_Testimonials),
    _createVNode(_component_OurTeam),
    _createVNode(_component_FAQ),
    _createVNode(_component_ContactUs),
    _createVNode(_component_CTA),
    _createVNode(_component_Footer),
    _createVNode(_component_CopyRight),
    _createVNode(_component_BackToUp)
  ]))
}